import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GridModule, RowFilterModule } from '@progress/kendo-angular-grid';
import { MultiDayValidationPage } from './multi-day';
import { DirectivesModule } from '../../../directives/directives.module';
import { PtKendoModule } from '../../../_foundation/kendo/modules/pt.kendo.module';

@NgModule({
  declarations: [
    MultiDayValidationPage
  ],
  imports: [
    IonicPageModule.forChild(MultiDayValidationPage),
    PtKendoModule,
    GridModule,
    RowFilterModule,
    DirectivesModule,
  ],
  providers: []
})
export class MultiDayPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/validation/multi-day/multi-day.module.ts